import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Loading, Modal, ModalFooter } from '@folio/stripes/components';
import { FormattedMessage } from 'react-intl';
import { useOkapiKy } from '@folio/stripes/core';
import { useIntl } from 'react-intl';
import { getLocalizedValue } from '../../helpers/localizationUtils';
import ExecutionHistoryTable from './ExecutionHistoryTable';

function ExecutionHistoryModal({ open, onClose, schedule }) {
  const okapiKy    = useOkapiKy();
  const { locale } = useIntl();
  const okapiKyRef = useRef(okapiKy);
  useEffect(() => { okapiKyRef.current = okapiKy; }, [okapiKy]);
  const scheduleName = getLocalizedValue(schedule?.name, locale) || '';

  const [executions, setExecutions] = useState([]);
  const [isLoading,  setIsLoading]  = useState(false);

  useEffect(() => {
    if (!open || !schedule?.id) return;
    setIsLoading(true);
    okapiKyRef.current
      .get(`report-executions?query=scheduledReportId%3D%3D${schedule.id}%20sortby%20executionDate%2Fsort.descending&limit=50`)
      .json()
      .then(res => setExecutions(res?.reportExecutions || []))
      .catch(() => setExecutions([]))
      .finally(() => setIsLoading(false));
  }, [open, schedule?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  // okapiKy via ref — no infinite loop

  return (
    <Modal
      open={open}
      onClose={onClose}
      label={
        <FormattedMessage
          id="ui-reports.executionHistory.modal.title"
          defaultMessage="Execution History: {name}"
          values={{ name: scheduleName }}
        />
      }
      footer={
        <ModalFooter>
          <Button buttonStyle="primary" onClick={onClose} marginBottom0>
            <FormattedMessage id="ui-reports.button.close" defaultMessage="Close" />
          </Button>
        </ModalFooter>
      }
      size="large"
    >
      {isLoading
        ? <div style={{ padding: '2rem', textAlign: 'center' }}><Loading /></div>
        : <ExecutionHistoryTable executions={executions} isLoading={false} />
      }
    </Modal>
  );
}

ExecutionHistoryModal.propTypes = {
  open:     PropTypes.bool.isRequired,
  onClose:  PropTypes.func.isRequired,
  schedule: PropTypes.object.isRequired,
};

export default ExecutionHistoryModal;
